export const JOURNEY_STATUS_TYPES = {
    ACTIVE: 'Active',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    NOT_STARTED: 'Not Started',
};
